import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import Timeline from "@/components/sections/Timeline";
import Contact from "@/components/sections/Contact";
import Testimonials from "@/components/sections/Testimonials";
import githubbage from "@/assets/githubbage.png";
import az900Badge from "@/assets/az-900_bage.png";
import az204Badge from "@/assets/az-204_bage.png";
import oracleBadgeAI from "@/assets/OAI.png";
import oracleBadgeInfra from "@/assets/OCI.png";
import Ovai from "@/assets/Ovai.png";
import Prototype1 from "@/assets/achivements/Prototype1.jpg";
import Project1 from "@/assets/achivements/Project1.jpg";
import Portotype2 from "@/assets/achivements/Portotype2.png";
import Portotype3 from "@/assets/achivements/Portotype3.jpg";
import Project3 from "@/assets/achivements/Project3.jpg";
import Project4 from "@/assets/achivements/Project4.jpg";
import Project5 from "@/assets/achivements/Project5.png";
import BookRecommendationSystem from "@/assets/achivements/BookRecommendationSystem.png";
import RecipeGeneratorAI from "@/assets/achivements/RecipeGeneratorAI.png";
import ISTE from "@/assets/achivements/ISTE.jpg";
import useScrollReveal from "@/hooks/useScrollReveal";
import Meta from "@/assets/Meta.png";
import uiHospital from '@/assets/achivements/ui_hospital.png';
import chefgpt_ui from '@/assets/achivements/chefgpt-ui.png';
import cloImage from '@/assets/projects/clo3d/CLO-ATELIER_1.png';
import resortHomeImage from '@/assets/projects/resort/resort_home_page.png';
// import hero_bg from "@/assets/hero_bg.jpg";
import { useEffect, useRef, useState } from "react";
import Navbar from "@/components/Navbar";
import { Link, useNavigate, useLocation } from 'react-router-dom';

import { BsTwitterX, BsGithub, BsInstagram, BsLinkedin, BsReddit, BsMailbox2Flag, BsYoutube } from "react-icons/bs";
import { SiOpenjdk, SiPython, SiCplusplus, SiTensorflow, SiPytorch, SiScikitlearn, SiNumpy, SiPandas, SiDocker, SiGit, SiLinux, SiPostgresql, SiReact, SiNodedotjs, SiTypescript } from "react-icons/si";
import { FaAws, FaCloudflare } from "react-icons/fa";
import { TbBrandAzure } from "react-icons/tb";
import {
  Github,
  Mail,
  ChevronDown,
  ExternalLink,
  Code,
  Palette,
  Globe,
  Database,
  Star,
  BrainCircuit,
  Library,
  Binary,
  Wrench,
  Cloud,
  Wifi,
  Router,
  Server,
  Zap,
  Shield,
  Network,
  Activity,
  Cpu,
  GitBranch,
  Monitor,
  Lock,
  Boxes,
  HardDrive,
  Workflow,
  Sparkles,
  FileCode,
  SquareTerminal,
  Youtube,
  ArrowRight,
  BookOpen
} from "lucide-react";

const skills = [
  {
    name: "Languages",
    icon: <Binary className="h-8 w-8" />,
    logos: [
      { name: "Java", icon: <SiOpenjdk className="h-8 w-8" color="#f89820" /> },
      { name: "Python", icon: <SiPython className="h-8 w-8" color="#3776AB" /> },
      { name: "C++", icon: <SiCplusplus className="h-8 w-8" color="#00599C" /> },
      { name: "TypeScript", icon: <SiTypescript className="h-8 w-8" color="#3178C6" /> },
    ],
  },
  {
    name: "Machine Learning",
    icon: <BrainCircuit className="h-8 w-8" />,
    logos: [
      { name: "scikit-learn", icon: <SiScikitlearn className="h-8 w-8" color="#F7931E" /> },
      { name: "NumPy", icon: <SiNumpy className="h-8 w-8" color="#013243" /> },
      { name: "Pandas", icon: <SiPandas className="h-8 w-8" color="#150458" /> },
      { name: "TensorFlow", icon: <SiTensorflow className="h-8 w-8" color="#FF6F00" /> },
      { name: "PyTorch", icon: <SiPytorch className="h-8 w-8" color="#EE4C2C" /> },
    ],
  },
  {
    name: "Web & Backend",
    icon: <Globe className="h-8 w-8" />,
    logos: [
      { name: "React", icon: <SiReact className="h-8 w-8" color="#61DAFB" /> },
      { name: "Node.js", icon: <SiNodedotjs className="h-8 w-8" color="#339933" /> },
      { name: "PostgreSQL", icon: <SiPostgresql className="h-8 w-8" color="#4169E1" /> },
    ],
  },
  {
    name: "DevTools & Cloud",
    icon: <Wrench className="h-8 w-8" />,
    logos: [
      { name: "Docker", icon: <SiDocker className="h-8 w-8" color="#2496ED" /> },
      { name: "Git", icon: <SiGit className="h-8 w-8" color="#F05032" /> },
      { name: "Linux", icon: <SiLinux className="h-8 w-8" color="#FCC624" /> },
    ],
  },
  {
    name: "Networking",
    icon: <Network className="h-8 w-8" />,
    logos: [
      { name: "TCP/IP", icon: <Network className="h-8 w-8" color="#38bdf8" /> },
      { name: "DNS", icon: <Globe className="h-8 w-8" color="#4ade80" /> },
      { name: "VPN", icon: <Shield className="h-8 w-8" color="#f87171" /> },
      { name: "Firewall", icon: <Shield className="h-8 w-8" color="#fb923c" /> },
      { name: "Wi-Fi", icon: <Wifi className="h-8 w-8" color="#a78bfa" /> },
      { name: "Routing", icon: <Router className="h-8 w-8" color="#facc15" /> },
    ],
  },
];

const marqueeTechnologies = [
  { name: "Python", logo: "/tech-logos/python.svg" },
  { name: "TypeScript", logo: "/tech-logos/typescript.svg" },
  { name: "React", logo: "/tech-logos/react.svg" },
  { name: "Node.js", logo: "/tech-logos/nodejs.svg" },
  { name: "PostgreSQL", logo: "/tech-logos/postgresql.svg" },
  { name: "Docker", logo: "/tech-logos/docker.svg" },
  { name: "Kubernetes", logo: "/tech-logos/kubernetes.svg" },
  { name: "AWS", icon: <FaAws className="h-5 w-5" color="#FF9900" /> },
  { name: "Azure", logo: "/tech-logos/azure.svg" },
  { name: "Cloudflare", logo: "/tech-logos/cloudflare.svg" },
];

const awsServices = [
  { name: "EC2", desc: "Virtual Servers", icon: <Server className="h-4 w-4" /> },
  { name: "S3", desc: "Object Storage", icon: <HardDrive className="h-4 w-4" /> },
  { name: "Lambda", desc: "Serverless", icon: <Zap className="h-4 w-4" /> },
  { name: "IAM", desc: "Access Management", icon: <Lock className="h-4 w-4" /> },
  { name: "VPC", desc: "Networking", icon: <Network className="h-4 w-4" /> },
  { name: "CloudWatch", desc: "Monitoring", icon: <Activity className="h-4 w-4" /> },
  { name: "SageMaker", desc: "ML Platform", icon: <Cpu className="h-4 w-4" /> },
  { name: "Bedrock", desc: "Generative AI", icon: <Sparkles className="h-4 w-4" /> },
  { name: "ECR / ECS", desc: "Containers", icon: <Boxes className="h-4 w-4" /> },
  { name: "CloudFormation", desc: "Infrastructure as Code", icon: <FileCode className="h-4 w-4" /> },
];

const azureServices = [
  { name: "App Service", desc: "Web Apps", icon: <Globe className="h-4 w-4" /> },
  { name: "Static Web Apps", desc: "Frontend Hosting", icon: <Monitor className="h-4 w-4" /> },
  { name: "Azure Functions", desc: "Serverless", icon: <Zap className="h-4 w-4" /> },
  { name: "Azure ML", desc: "Machine Learning", icon: <Cpu className="h-4 w-4" /> },
  { name: "Azure Storage", desc: "Blob, Files, Queues", icon: <Database className="h-4 w-4" /> },
  { name: "Azure SQL", desc: "Managed Database", icon: <Database className="h-4 w-4" /> },
  { name: "Virtual Machines", desc: "Compute", icon: <Server className="h-4 w-4" /> },
  { name: "Azure DevOps", desc: "CI/CD", icon: <GitBranch className="h-4 w-4" /> },
  { name: "Azure AI Services", desc: "AI APIs", icon: <Sparkles className="h-4 w-4" /> },
  { name: "Azure Monitor", desc: "Monitoring", icon: <Activity className="h-4 w-4" /> },
];

const cloudflareServices = [
  { name: "Workers", desc: "Serverless Functions", icon: <Zap className="h-4 w-4" /> },
  { name: "Pages", desc: "Static Hosting", icon: <Globe className="h-4 w-4" /> },
  { name: "R2", desc: "Object Storage", icon: <HardDrive className="h-4 w-4" /> },
  { name: "DNS", desc: "DNS Management", icon: <Network className="h-4 w-4" /> },
  { name: "CDN", desc: "Global CDN", icon: <Globe className="h-4 w-4" /> },
  { name: "Zero Trust", desc: "Security", icon: <Shield className="h-4 w-4" /> },
];

const certifications = [
  {
    title: "Developing Solutions for Microsoft Azure",
    issuer: "Microsoft",
    date: "Jun 2025",
    image: az204Badge,
    link: "https://learn.microsoft.com/api/credentials/share/en-us/MohanBalaji-7174/732B4065AC26B8CE?sharingId=40E742C63BF39CC0",
  },
  {
    title: "Microsoft Azure Fundamentals",
    issuer: "Microsoft",
    date: "Feb 2025",
    image: az900Badge,
    link: "https://learn.microsoft.com/api/credentials/share/en-us/MohanBalaji-7174/4A60B073009EB146?sharingId=40E742C63BF39CC0"
  },
  {
    title: "GitHub Foundations",
    issuer: "GitHub",
    date: "March 2025",
    image: githubbage,
    link: "https://www.credly.com/badges/fbf7762c-2fe9-4bb6-8e73-2487cb8d4454/" // Replace with your actual certificate link 
  },
  {
    title: " Oracle AI Vector Search Certified Professional",
    issuer: "Oracle",
    date: "2025",
    image: Ovai,
    link: "https://catalog-education.oracle.com/ords/certview/sharebadge?id=C3D91D371DE159F3337A5795A81159FA299B77D8BC14F13F6121AEEF30AA6C3D"
  },
  {
    title: "Oracle Cloud Infrastructure AI Certified Foundations",
    issuer: "Oracle",
    date: "2025",
    image: oracleBadgeAI,
    link: "https://catalog-education.oracle.com/ords/certview/sharebadge?id=805B313D54435063BFE2FF5425D403B97820AF27B859254A4779725559215662"
  },
  {
    title: "Oracle Cloud Infrastructure 2024 Certified Foundations Associates",
    issuer: "Oracle",
    date: "2025",
    image: oracleBadgeInfra,
    link: "https://catalog-education.oracle.com/ords/certview/sharebadge?id=805B313D54435063BFE2FF5425D403B97820AF27B859254A4779725559215662"
  },
  {
    title: "Introduction to Front-End Development",
    issuer: "Meta (via Coursera)",
    date: "2024",
    image: Meta,
    link: "https://www.coursera.org/account/accomplishments/verify/SJ63NFER6MY7" // Replace with the actual certificate link
  }

];

const achievements = [
  {
    title: "First Prize - Science Day Project Expo",
    issuer: "R.M.D Engineering College",
    date: "March 2023", // Add actual date if available
    image: Prototype1, // Replace with actual image import
    link: "https://youtu.be/GyG84TlI-rc", // Replace with actual link
  },
  {
    title: "First Prize - Intra-Department Hackathon",
    issuer: "R.M.D Engineering College",
    date: "August 2024", // Add actual date if available
    image: Portotype2, // Replace with actual image import
    link: "https://github.com/Mohan-Balaji/Automated_Public_Lighting", // Replace with actual link
  },
  {
    title: "3rd Place --- IDEATHON 2023 Institute's Innovation Council (IIC) & RMDEC-IDEA Lab",
    issuer: "R.M.D Engineering College",
    date: "October 2024", // Add actual date if available
    image: Portotype3, // Replace with actual image import
    link: "", // Replace with actual link
  },
  {
    "title": "Shortlisted for Smart India Hackathon (SIH) 2024",
    "issuer": "R.M.D Engineering College",
    "date": "2024",
    "image": Project3,  // Replace with actual image import
    "link": "https://youtu.be/r6CCejWSwXM"  // Replace with actual link if available
  },
  {
    "title": "Third Place - Hackathon at 23rd ISTE TN Section Convention",
    "issuer": "Adhiyamaan College of Engineering",
    "date": "2025",
    "image": ISTE,  // Replace with actual image import
    "link": "https://youtu.be/r6CCejWSwXM"  // Replace with actual link if available
  }
  
];

export const projects = [
  // SOFTWARE PROJECTS
  {
    "title": "CLO3D Garment Plugin (AI-Powered)",
    "description": "Developed an AI-powered integration that bridges Claude AI with CLO3D (professional 3D garment design software) via a WebSocket-based MCP server, enabling natural language-driven garment discovery, import, and design workflow automation.",
    "technologies": [
      "TypeScript",
      "Node.js",
      "MCP Protocol",
      "WebSocket",
      "TCP/IP",
      "LLM APIs"
    ],
    "features": [
      "Multi-Client Concurrency",
      "Streaming Response Protocol",
      "Process Isolation",
      "Dynamic Plugin Registration",
      "Conversational History Context"
    ],
    "image": cloImage,
    "liveDemo": "",
    "sourceCode": "",
    "url":"/CLO3D_Garment_Plugin",
    "category": "software",
    "status": "Active",
    "role": "Software Engineer Intern",
    "duration": "Ongoing",
    "impact": "Engineered real-time LLM streaming with tool orchestration pipeline reducing UI latency and design workflow times."
  },
  {
    "title": "Hospital Readmission Prediction System",
    "description": "A meta-classifier ensemble system that predicts hospital readmission risk with >78% accuracy using advanced machine learning algorithms. Features explainable AI insights with SHAP, dual-mode interface for manual and batch processing, and enterprise-grade Azure deployment with HIPAA-ready compliance.",
    "technologies": [
      "React 19",
      "FastAPI",
      "Python 3.12",
      "XGBoost",
      "Random Forest",
      "SHAP",
      "Azure Static Web Apps",
      "Azure App Service",
      "Firebase Auth",
      "Machine Learning",
      "Explainable AI"
    ],
    "features": [
      "Meta-classifier ensemble with >78% accuracy",
      "SHAP explainable AI for transparent predictions",
      "Dual input modes (manual + Excel batch processing)",
      "Real-time risk stratification (Low/Medium/High)",
      "Enterprise authentication with Firebase",
      "Azure cloud deployment with auto-scaling",
      "HIPAA-ready compliance and security",
      "Interactive dashboard with visualizations"
    ],
    "image": uiHospital,
    "liveDemo": "",
    "sourceCode": "https://github.com/Mohan-Balaji/hospital-readmission-prediction",
    "url": "/Hospital_Readmission_Prediction_System",
    "category": "software",
    "status": "Live",
    "role": "Team Lead & ML Engineer",
    "duration": "6 weeks",
    "impact": "Reduced healthcare costs by enabling early intervention for high-risk patients"
  },
  {
    "title": "Homelab Cloud Storage with TrueNAS & Cloudflare",
    "description": "A sophisticated self-hosted cloud storage solution leveraging TrueNAS Scale on repurposed enterprise hardware. Features include secure remote access via Cloudflare Tunnel, automated backups, media streaming capabilities, and containerized applications. The system provides enterprise-grade storage with data redundancy, encryption, and monitoring while maintaining cost-effectiveness.",
    "technologies": [
      "TrueNAS Scale",
      "Cloudflare Tunnel",
      "Docker",
      "ZFS",
      "RAID",
      "Self-Hosting",
      "Networking",
      "Linux",
      "Shell Scripting"
    ],
    "features": [
      "Secure remote access with Cloudflare Tunnel",
      "Data redundancy with ZFS RAID",
      "Automated backup system",
      "Media streaming capabilities",
      "Containerized applications",
      "Resource monitoring and alerts",
      "Cost-effective enterprise storage"
    ],
    "image": Project4,
    "liveDemo": "https://www.linkedin.com/posts/mohanbalaji2004_homelab-cloudstorage-truenas-activity-7300806416041226240-bqds?utm_source=social_share_send&utm_medium=member_desktop_web&rcm=ACoAAEJl9QMBe0AZIgLyMU7kLInYlGVog21SO0I",
    "sourceCode": "https://github.com/Mohan-Balaji/homelab-cloud",
    "url":"/Homelab_Cloud_Storage",
    "category": "software",
    "status": "Active",
    "role": "System Architect & Developer",
    "duration": "4 hours",
    "impact": "Reduced storage costs by 70% while providing enterprise-grade features"
  },
  {
    "title": "MS Castle Resort Booking Platform",
    "description": "A comprehensive Airbnb-style resort booking web application for MS Castle. Features real-time booking slots, instant WhatsApp booking notifications, a protected admin panel, and robust security leveraging Firebase Auth and Firestore database.",
    "technologies": [
      "React",
      "Vite",
      "Tailwind CSS",
      "Firebase Auth",
      "Firestore DB",
      "WhatsApp API"
    ],
    "features": [
      "Airbnb-style immersive property galleries and UI layout",
      "Real-time booking slots syncing instantly across all users",
      "Instant booking notifications sent directly via WhatsApp",
      "Dedicated Admin panel to manage dates and approve requests",
      "Secure Google login powered by Firebase Auth",
      "High-performance NoSQL database using Cloud Firestore"
    ],
    "image": resortHomeImage,
    "liveDemo": "https://mscastlekodaikanal.web.app/",
    "sourceCode": "",
    "url": "/MS_Castle_Booking_App",
    "category": "software",
    "status": "Active",
    "role": "Full Stack Developer",
    "duration": "1 month",
    "impact": "Transformed manual resort reservations into a modern Airbnb-style experience with instant WhatsApp alerts and real-time slot synchronization."
  },
  {
    "title": "AI-Powered Book Recommender System",
    "description": "An intelligent book recommendation platform that uses machine learning algorithms to suggest personalized reading materials based on user preferences, reading history, and collaborative filtering. The system provides accurate recommendations, user-friendly interface, and real-time updates to enhance the reading discovery experience.",
    "technologies": [
      "Machine Learning",
      "Python",
      "Collaborative Filtering",
      "Flask",
      "HTML",
      "CSS",
      "JavaScript"
    ],
    "features": [
      "AI-powered recommendation engine",
      "Personalized user experience",
      "Real-time book suggestions",
      "User preference learning",
      "Collaborative filtering system",
      "Modern responsive interface",
      "Secure user authentication"
    ],
    "image": BookRecommendationSystem,
    "liveDemo": "https://mohanbalaji.vercel.app/book-recommender",
    "sourceCode": "https://github.com/Mohan-Balaji/book-recommender",
    "url": "/book-recommender",
    "category": "software",
    "status": "Live",
    "role": "Full Stack Developer",
    "duration": "3 weeks",
    "impact": "Improved book discovery by 85% through intelligent AI recommendations"
  },
  {
    "title": "AI Recipe Generator & Meal Planner",
    "description": "An intelligent recipe generation system that creates personalized meal plans and recipes based on available ingredients, dietary restrictions, and user preferences. The AI-powered platform suggests creative cooking ideas, nutritional information, and step-by-step instructions for delicious meals.",
    "technologies": [
      "React",
      "Node.js",
      "OpenAI API",
      "Python",
      "PostgreSQL",
      "REST API",
      "AI/ML Integration",
      "User Authentication",
      "Responsive Design"
    ],
    "features": [
      "AI-powered recipe generation",
      "Personalized meal planning",
      "Ingredient-based suggestions",
      "Dietary restriction support",
      "Nutritional information",
      "Step-by-step instructions",
      "User preference learning"
    ],
    "image": chefgpt_ui,
    "liveDemo": "https://mohanbalaji.vercel.app/recipe-generator-ai",
    "sourceCode": "https://github.com/Mohan-Balaji/recipe-generator-ai",
    "url": "/recipe-generator-ai",
    "category": "software",
    "status": "Live",
    "role": "Full Stack Developer",
    "duration": "4 weeks",
    "impact": "Reduced meal planning time by 70% through AI-powered recipe suggestions"
  },
  {
    "title": "Avinyaa 2025 Website Development",
    "description": "Led the website development team for Avinyaa 2025, the flagship symposium of R.M.D. Engineering College AIML Department. Engineered a fully customized website optimizing performance, usability, and accessibility, with a focus on seamless integration and deployment.",
    "technologies": ["React", "Next.js", "Tailwind CSS", "Vercel", "GitHub Actions"],
    "features": [
      "Custom event registration system",
      "Responsive and accessible design",
      "Automated deployment with Vercel",
      "CI/CD integration via GitHub Actions",
      "SEO optimization",
      "Team collaboration tools"
    ],
    "image": Project5,
    "liveDemo": "https://avinyaa2025.web.app",
    "sourceCode": "https://github.com/Mohan-Balaji/Symposium-Website",
    "url":"/Avinyaa_2025",
    "category": "software",
    "status": "Completed",
    "role": "Team Lead & Full Stack Developer",
    "duration": "7 Days",
    "impact": "Enabled 500+ registrations and seamless event management for the symposium"
  },

  
  // HARDWARE PROJECTS
  {
    "title": "Dual-Axis Solar Tracker",
    "description": "A system that optimizes solar energy collection by adjusting solar panels in two axes to follow the sun.",
    "technologies": ["Arduino", "Servo Motors", "LDR Sensors", "Solar Panel"],
    "features": [
      "Dual-axis sun tracking",
      "Automated panel adjustment",
      "Real-time light intensity monitoring",
      "Energy efficiency optimization",
      "Weather-resistant design"
    ],
    "image": Project1,
    "liveDemo": "https://youtu.be/GyG84TlI-rc?si=CC0333TKLqY8AniB",
    "sourceCode": "https://github.com/Mohan-Balaji/Dual_Axis_Solar_Tracker",
    "url":"/Dual_Axis_Solar_Tracker",
    "category": "hardware",
    "status": "Completed",
    "role": "Hardware Designer & Programmer",
    "duration": "1 month",
    "impact": "Improved solar energy capture by 25% compared to static panels"
  },
  {
    "title": "Automated Public Lighting System",
    "description": "An advanced lighting system designed to optimize energy capture and utilization by improving the positioning of solar panels in public lighting solutions.",
    "technologies": ["IoT", "Solar Panels", "Microcontrollers", "Sensors"],
    "features": [
      "Solar panel optimization",
      "Smart scheduling",
      "Remote monitoring",
      "Energy management",
      "Battery management system"
    ],
    "image": Portotype2,
    "liveDemo": "https://drive.google.com/file/d/1d88jovHwJQ6_0Yk_XyNJ_IVmT4EnAcOb/view?usp=drivesdk",
    "sourceCode": "https://github.com/Mohan-Balaji/Automated_Public_Lighting.git",
    "url":"/Automated_Public_Lighting_System",
    "category": "hardware",
    "status": "Active",
    "role": "Lead Developer & System Designer",
    "duration": "2 months",
    "impact": "Achieved 40% energy savings in public lighting operations"
  },
  {
    "title": "Smart Irrigation System using Precision Farming",
    "description": "A system that optimizes water usage in agriculture by monitoring soil moisture levels and controlling irrigation accordingly.",
    "technologies": ["IoT", "Soil Moisture Sensors", "Arduino", "Automated Watering"],
    "features": [
      "Precision watering",
      "Weather integration",
      "Remote monitoring",
      "Crop-specific profiles",
      "Automated valve control"
    ],
    "image": Project3,
    "liveDemo": "https://youtu.be/r6CCejWSwXM",
    "sourceCode": "https://github.com/Mohan-Balaji/Smart-Irrigation-System-using-Precision-Farming",
    "url":"/Smart_Irrigation_System_using_Precision_Farming",
    "category": "hardware",
    "status": "Completed",
    "role": "Lead Developer & System Architect",
    "duration": "1 week",
    "impact": "Reduced water usage by 60% while improving crop yield"
  }
];


const Index = () => {
  const scrollToProjects = () => {
    document.getElementById('projects')?.scrollIntoView({ behavior: 'smooth' });
  };

  const scrollToCurrentBuild = () => {
    document.getElementById('current-build')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <>
      <main className="min-h-screen bg-background w-full overflow-x-hidden">
        {/* Hero */}
        <section id="hero" className="relative w-full min-h-[calc(100svh-4rem)] flex items-center lg:items-start overflow-hidden">
          <div className="hero-grid"></div>
          <div className="hero-grid hero-grid-fine"></div>
          <div className="hero-glow hero-glow-one"></div>
          <div className="hero-glow hero-glow-two"></div>
          <div className="hero-spotlight"></div>
          <div className="hero-beam"></div>
          <div className="hero-particle hero-particle-one"></div>
          <div className="hero-particle hero-particle-two"></div>
          <div className="hero-particle hero-particle-three"></div>
          <div className="hero-particle hero-particle-four"></div>
          <div className="absolute inset-0 pointer-events-none bg-gradient-to-b from-transparent via-background/20 to-background"></div>
          <div className="max-w-6xl mx-auto px-6 py-16 md:py-20 lg:pt-20 lg:pb-8 relative w-full hero-entrance">
            <h1 className="font-display text-[clamp(3rem,14vw,3.5rem)] sm:text-6xl md:text-8xl lg:text-[7.5rem] leading-[0.84] tracking-[-0.06em] text-foreground max-w-5xl">
              <span className="block">Mohan Balaji</span>
            </h1>
            <div className="mt-5 flex flex-wrap items-center gap-3">
              <span className="inline-flex items-center gap-2 text-xs text-muted-foreground border border-border rounded-full px-3 py-1.5">
                <span className="h-1.5 w-1.5 rounded-full bg-green-400 animate-pulse"></span>
                Available for work
              </span>
              <span className="text-xs text-muted-foreground">Software · Cloud · AI Systems</span>
            </div>
            <div className="mt-5 grid md:grid-cols-2 gap-6 items-start">
              <div className="max-w-xl">
                <p className="text-lg md:text-xl text-muted-foreground leading-relaxed">
                  I build dependable software, cloud systems, and intelligent products for real-world problems.
                </p>
                <div className="hidden md:grid mt-5 gap-3 sm:grid-cols-3">
                  <div className="rounded-xl border border-border bg-card/70 px-4 py-3 backdrop-blur-sm transition-colors hover:border-primary/30">
                    <p className="text-[10px] uppercase tracking-[0.18em] text-muted-foreground">Availability</p>
                    <p className="mt-2 text-sm font-medium leading-snug text-foreground">Open to high-impact roles</p>
                  </div>
                  <div className="rounded-xl border border-border bg-card/70 px-4 py-3 backdrop-blur-sm transition-colors hover:border-primary/30">
                    <p className="text-[10px] uppercase tracking-[0.18em] text-muted-foreground">Specialism</p>
                    <p className="mt-2 text-sm font-medium leading-snug text-foreground">Cloud, AI & systems</p>
                  </div>
                  <div className="rounded-xl border border-border bg-card/70 px-4 py-3 backdrop-blur-sm transition-colors hover:border-primary/30">
                    <p className="text-[10px] uppercase tracking-[0.18em] text-muted-foreground">Strength</p>
                    <p className="mt-2 text-sm font-medium leading-snug text-foreground">Systems thinking & execution</p>
                  </div>
                </div>
              </div>
              <div className="md:justify-self-end w-full max-w-sm md:border-l md:border-border md:pl-6 space-y-4 md:space-y-6">
                <div className="hidden md:block">
                  <p className="text-xs uppercase tracking-[0.2em] text-muted-foreground mb-3">Focus areas</p>
                  <p className="text-sm leading-relaxed text-foreground">Agentic AI · Cloud Engineering · AI/ML · Full-stack Systems · IoT/Embedded</p>
                </div>
                <button
                  type="button"
                  onClick={scrollToCurrentBuild}
                  className="group w-full rounded-2xl border border-primary/35 bg-gradient-to-br from-primary/10 via-card to-card p-5 text-left shadow-[0_16px_45px_rgba(0,0,0,0.26)] transition-all hover:-translate-y-0.5 hover:border-primary/60 hover:shadow-[0_18px_55px_rgba(0,0,0,0.38)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
                  aria-label="View the agent environment currently being built"
                >
                  <span className="flex items-center gap-2 text-[10px] font-medium uppercase tracking-[0.18em] text-primary">
                    <span className="h-1.5 w-1.5 rounded-full bg-primary animate-pulse"></span>
                    Currently building
                  </span>
                  <span className="mt-2 flex items-center justify-between gap-4 text-base font-semibold text-foreground">
                    Agent Environment
                    <ArrowRight className="h-4 w-4 shrink-0 transition-transform group-hover:translate-x-1" />
                  </span>
                  <span className="mt-1.5 block text-xs leading-relaxed text-muted-foreground">Tool-aware AI agents with memory, guardrails and observability.</span>
                </button>
              </div>
            </div>
            <div className="mt-4 flex flex-wrap gap-3">
              <Button
                className="rounded-full px-6 h-11"
                onClick={() => window.open('https://www.linkedin.com/in/mohanbalaji2004/', '_blank', 'noopener,noreferrer')}
              >
                Start a conversation <ArrowRight className="ml-2 h-4 w-4" />
              </Button>
              <Button variant="outline" className="rounded-full px-6 h-11" onClick={scrollToProjects}>
                Selected work
              </Button>
              <Button variant="outline" className="rounded-full px-6 h-11" onClick={() => (window.location.href = '/blog')}>
                Writing
              </Button>
            </div>
            <div className="mt-5 flex items-center gap-2 text-sm text-muted-foreground border-t border-border pt-3">
              <a href="https://github.com/Mohan-Balaji" target="_blank" rel="noopener noreferrer" aria-label="GitHub" title="GitHub" className="flex h-9 w-9 items-center justify-center rounded-lg border border-border bg-card text-muted-foreground transition-all hover:-translate-y-0.5 hover:border-primary/40 hover:text-foreground">
                <BsGithub className="h-4 w-4" />
              </a>
              <a href="https://www.linkedin.com/in/mohanbalaji2004/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" title="LinkedIn" className="flex h-9 w-9 items-center justify-center rounded-lg border border-border bg-card text-muted-foreground transition-all hover:-translate-y-0.5 hover:border-primary/40 hover:text-[#0A66C2]">
                <BsLinkedin className="h-4 w-4" />
              </a>
              <a href="https://www.youtube.com/@TechWithMohan" target="_blank" rel="noopener noreferrer" aria-label="YouTube" title="YouTube" className="flex h-9 w-9 items-center justify-center rounded-lg border border-border bg-card text-muted-foreground transition-all hover:-translate-y-0.5 hover:border-primary/40 hover:text-[#FF0000]">
                <BsYoutube className="h-4 w-4" />
              </a>
              <span className="ml-auto text-xs">Scroll to explore</span>
            </div>
          </div>
        </section>

        {/* Marquee */}
        <div className="border-y border-border bg-muted/30 overflow-hidden py-5">
          <div className="flex animate-marquee whitespace-nowrap">
            {Array.from({ length: 2 }).map((_, i) => (
              <div key={i} className="flex items-center gap-3 px-3">
                {marqueeTechnologies.map((technology) => (
                  <div key={`${i}-${technology.name}`} className="inline-flex items-center gap-2 rounded-full border border-border bg-card px-4 py-2 text-xs font-medium text-muted-foreground">
                    {technology.logo ? (
                      <img src={technology.logo} alt="" className="h-5 w-5 object-contain" />
                    ) : technology.icon}
                    <span>{technology.name}</span>
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>

        {/* About */}
        <section id="about" className="border-t border-border">
          <div className="max-w-6xl mx-auto px-6 py-24 md:py-32 grid md:grid-cols-12 gap-10 md:gap-16">
            <div className="md:col-span-4">
              <p className="text-xs uppercase tracking-[0.2em] text-muted-foreground mb-6">01 --- About</p>
              <h2 className="font-display text-4xl md:text-5xl leading-[1.05] text-foreground">
                Building systems with care and craft.
              </h2>
            </div>
            <div className="md:col-span-8 space-y-6 text-muted-foreground leading-relaxed text-base md:text-lg">
              <p>
                I'm a developer and engineer who builds agentic AI systems, cloud-native platforms, and hardware-software integrations --- from ML pipelines to IoT devices and embedded systems. I work at the intersection of practical engineering and thoughtful design to ship things that hold up in production.
              </p>
              <p>
                I care about systems that are robust, readable and genuinely useful: clear data flows, sensible defaults, and interfaces that stay out of the way. Most of my projects start from a real constraint --- cost, latency, or a missing tool --- and grow into production-ready solutions. I build agentic environments that give AI agents reach, tools, and safe boundaries.
              </p>
              <div className="grid sm:grid-cols-2 gap-8 pt-6 border-t border-border">
                <div>
                  <h4 className="text-sm font-medium text-foreground mb-3">Contact</h4>
                  <ul className="space-y-2 text-sm">
                    <li className="flex items-center gap-3">
                      <Mail className="h-4 w-4 text-muted-foreground" />
                      <span className="hover:text-foreground transition-colors cursor-pointer" onClick={() => (window.location.href = 'mailto:bmohanbalaji1976@gmail.com')}>
                        bmohanbalaji1976@gmail.com
                      </span>
                    </li>
                    <li className="flex items-center gap-3">
                      <span className="text-muted-foreground">+91 8925236216</span>
                    </li>
                    <li className="flex items-center gap-3">
                      <span className="text-muted-foreground">Ambattur, Chennai -. India</span>
                    </li>
                  </ul>
                </div>
                <div>
                  <h4 className="text-sm font-medium text-foreground mb-3">Focus</h4>
                  <div className="flex flex-wrap gap-2">
                    {['Cloud Computing', 'AI / ML', 'IoT Systems', 'Full Stack'].map((t) => (
                      <span key={t} className="text-xs px-3 py-1 border border-border rounded-full text-muted-foreground">{t}</span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <Timeline />

        {/* Skills */}
        <section id="skills" className="border-t border-border bg-muted/40">
          <div className="max-w-6xl mx-auto px-6 py-24 md:py-32">
            <div className="mb-12 md:mb-16">
              <p className="text-xs uppercase tracking-[0.2em] text-muted-foreground mb-6">02 --- Skills</p>
              <h2 className="font-display text-4xl md:text-5xl leading-[1.05] text-foreground max-w-3xl">
                From prototype to dependable production systems.
              </h2>
            </div>

            <div className="rounded-[20px] border border-border bg-card overflow-hidden">
              <div className="grid gap-6 border-b border-border p-8 md:grid-cols-[auto_1fr] md:items-center">
                <div className="flex h-14 w-14 items-center justify-center rounded-xl bg-primary/10 text-primary">
                  <BrainCircuit className="h-7 w-7" />
                </div>
                <div>
                  <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
                    <h3 className="font-medium text-foreground">Agentic AI Systems</h3>
                    <span className="text-[10px] uppercase tracking-[0.16em] text-primary">Featured capability</span>
                  </div>
                  <p className="mt-2 max-w-3xl text-sm leading-relaxed text-muted-foreground">
                    I design agent workflows that plan, use tools, retrieve the right context and remain observable—so AI capabilities become dependable parts of a product, not isolated demos.
                  </p>
                  <div className="mt-4 flex flex-wrap gap-2">
                    {['Tool orchestration', 'RAG & memory', 'Evaluation', 'Guardrails', 'Workflow observability'].map((capability) => (
                      <span key={capability} className="rounded-full border border-border px-3 py-1 text-xs text-muted-foreground">{capability}</span>
                    ))}
                  </div>
                </div>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 divide-y sm:divide-y-0 sm:divide-x divide-border">
                {skills.map((skill, index) => (
                  <div key={index} className="p-8 hover:bg-muted/40 transition-colors">
                    <div className="text-primary mb-5">{skill.icon}</div>
                    <h3 className="font-medium text-foreground mb-5">{skill.name}</h3>
                    <div className="flex flex-wrap gap-4">
                      {skill.logos.map((l, i) => (
                        <div key={i} className="flex flex-col items-center gap-1.5 text-muted-foreground hover:text-foreground transition-colors" title={l.name}>
                          {l.icon}
                          <span className="text-[10px] uppercase tracking-wider">{l.name}</span>
                        </div>
                      ))}
                    </div>
                    {skill.services && (
                      <p className="mt-5 text-xs text-muted-foreground leading-relaxed">{skill.services}</p>
                    )}
                  </div>
                ))}
              </div>

              <div className="border-t border-border p-8">
                <div className="flex flex-col md:flex-row md:items-center gap-6">
                  <div className="text-primary"><Cloud className="h-8 w-8" /></div>
                  <div>
                    <h3 className="font-medium text-foreground mb-2">Cloud Platforms</h3>
                    <div className="flex items-center gap-6 mb-2">
                      <div className="flex items-center gap-2 text-muted-foreground hover:text-foreground transition-colors" title="AWS">
                        <FaAws className="h-6 w-6" color="#FF9900" />
                        <span className="text-xs uppercase tracking-wider">AWS</span>
                      </div>
                      <div className="flex items-center gap-2 text-muted-foreground hover:text-foreground transition-colors" title="Azure">
                        <TbBrandAzure className="h-6 w-6" color="#0078D4" />
                        <span className="text-xs uppercase tracking-wider">Azure</span>
                      </div>
                      <div className="flex items-center gap-2 text-muted-foreground hover:text-foreground transition-colors" title="Cloudflare">
                        <FaCloudflare className="h-6 w-6" color="#F38020" />
                        <span className="text-xs uppercase tracking-wider">Cloudflare</span>
                      </div>
                    </div>
                    <p className="text-xs text-muted-foreground leading-relaxed">
                      AWS: EC2, S3, Lambda | Azure: App Service, Static Web Apps, Functions | Cloudflare: Workers, Pages, R2
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Currently building */}
        <section id="current-build" className="border-t border-border bg-background">
          <div className="max-w-6xl mx-auto px-6 py-24 md:py-32">
            <div className="rounded-2xl border border-border overflow-hidden bg-card">
              <div className="grid lg:grid-cols-12">
                <div className="lg:col-span-5 p-8 md:p-12 border-b lg:border-b-0 lg:border-r border-border">
                  <div className="inline-flex items-center gap-2 rounded-full border border-primary/30 bg-primary/10 px-3 py-1.5 text-[10px] font-medium uppercase tracking-[0.18em] text-primary">
                    <span className="h-1.5 w-1.5 rounded-full bg-primary animate-pulse"></span>
                    Currently building
                  </div>
                  <h2 className="font-display mt-8 text-4xl md:text-5xl leading-[0.96] text-foreground">
                    Agent<br />Environment.
                  </h2>
                  <p className="mt-6 text-base leading-relaxed text-muted-foreground max-w-md">
                    A focused environment for designing, orchestrating and evaluating AI agents that can use tools, retain context and run dependable workflows.
                  </p>
                  <div className="mt-8 space-y-3">
                    {[
                      "Tool orchestration & reliable execution",
                      "Context-aware memory and retrieval",
                      "Observable, secure agent workflows",
                    ].map((item) => (
                      <div key={item} className="flex items-center gap-3 text-sm text-foreground">
                        <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary"><ArrowRight className="h-3 w-3" /></span>
                        {item}
                      </div>
                    ))}
                  </div>
                  <p className="mt-10 text-xs uppercase tracking-[0.16em] text-muted-foreground">Architecture in progress · 2026</p>
                </div>
                <div className="lg:col-span-7 relative min-h-[420px] overflow-hidden agent-environment">
                  <div className="absolute inset-0 agent-environment-grid"></div>
                  <div className="relative z-10 p-6 md:p-10 h-full flex flex-col">
                    <div className="flex items-center justify-between text-[10px] uppercase tracking-[0.18em] text-muted-foreground">
                      <span>Agent runtime / v0.1</span>
                      <span className="flex items-center gap-1.5"><span className="h-1.5 w-1.5 rounded-full bg-green-400"></span>System design</span>
                    </div>
                    <div className="grid grid-cols-2 gap-3 md:gap-5 my-auto max-w-lg mx-auto w-full">
                      <div className="agent-node agent-node-delay-1 col-span-2">
                        <BrainCircuit className="h-5 w-5 text-primary" />
                        <div><p className="text-sm font-medium text-foreground">Agent Orchestrator</p><p className="text-xs text-muted-foreground">Planning, routing & execution</p></div>
                      </div>
                      <div className="agent-node agent-node-delay-2">
                        <Workflow className="h-5 w-5 text-primary" />
                        <div><p className="text-sm font-medium text-foreground">Tool Layer</p><p className="text-xs text-muted-foreground">APIs & automations</p></div>
                      </div>
                      <div className="agent-node agent-node-delay-3">
                        <Database className="h-5 w-5 text-primary" />
                        <div><p className="text-sm font-medium text-foreground">Memory</p><p className="text-xs text-muted-foreground">Context & retrieval</p></div>
                      </div>
                      <div className="agent-node agent-node-delay-4">
                        <Activity className="h-5 w-5 text-primary" />
                        <div><p className="text-sm font-medium text-foreground">Observability</p><p className="text-xs text-muted-foreground">Tracing & evaluation</p></div>
                      </div>
                      <div className="agent-node agent-node-delay-5">
                        <Shield className="h-5 w-5 text-primary" />
                        <div><p className="text-sm font-medium text-foreground">Guardrails</p><p className="text-xs text-muted-foreground">Permissions & safety</p></div>
                      </div>
                    </div>
                    <div className="flex items-center gap-2 text-xs text-muted-foreground"><span className="h-1.5 w-1.5 rounded-full bg-primary animate-pulse"></span>Designing the foundation</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Projects */}
        <section id="projects" className="border-t border-border">
          <div className="max-w-6xl mx-auto px-6 py-24 md:py-32">
            <div className="mb-16 md:mb-20">
              <p className="text-xs uppercase tracking-[0.2em] text-muted-foreground mb-6">03 --- Work</p>
              <h2 className="font-display text-4xl md:text-5xl leading-[1.05] text-foreground">
                Selected projects.
              </h2>
            </div>
            <div className="space-y-24 md:space-y-32">
              {projects.map((project, index) => (
                <article key={index} className="grid md:grid-cols-12 gap-8 md:gap-12 items-start group">
                  <div className="md:col-span-7">
                    <div className="aspect-[16/10] overflow-hidden rounded-xl bg-muted border border-border">
                      <img
                        src={project.image}
                        alt={project.title}
                        className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                        loading="lazy"
                      />
                    </div>
                  </div>
                  <div className="md:col-span-5 md:pt-4">
                    <div className="flex items-baseline gap-4 mb-4">
                      <span className="font-display text-5xl text-muted-foreground/30 leading-none">
                        {(index + 1).toString().padStart(2, '0')}
                      </span>
                      <p className="text-xs uppercase tracking-[0.2em] text-muted-foreground">
                        {project.category} - {project.status}
                      </p>
                    </div>
                    <h3 className="font-display text-2xl md:text-3xl mb-3 text-foreground leading-tight">
                      {project.title}
                    </h3>
                    <p className="text-muted-foreground leading-relaxed mb-6">{project.description}</p>
                    <div className="flex flex-wrap gap-1.5 mb-6">
                      {project.technologies.slice(0, 6).map((t, i) => (
                        <span key={i} className="text-xs px-2.5 py-1 border border-border rounded-full text-muted-foreground">
                          {t}
                        </span>
                      ))}
                    </div>
                    <div className="flex items-center gap-5 text-sm">
                      {project.url && (
                        <a href={project.url} className="inline-flex items-center gap-2 text-primary font-medium hover:gap-3 transition-all">
                          View case study
                          <ArrowRight className="h-4 w-4" />
                        </a>
                      )}
                      {project.liveDemo && (
                        <a href={project.liveDemo} target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">
                          Live ---
                        </a>
                      )}
                      {project.sourceCode && (
                        <a href={project.sourceCode} target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">
                          Code ---
                        </a>
                      )}
                    </div>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>

        {/* Certifications */}
        <section id="certifications" className="border-t border-border bg-muted/40">
          <div className="max-w-6xl mx-auto px-6 py-24 md:py-32">
            <div className="mb-12 md:mb-16">
              <p className="text-xs uppercase tracking-[0.2em] text-muted-foreground mb-6">04 --- Credentials</p>
              <h2 className="font-display text-4xl md:text-5xl leading-[1.05] text-foreground">Certifications.</h2>
            </div>
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
              {certifications.map((cert, index) => (
                <a
                  key={index}
                  href={cert.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group flex items-center gap-4 border border-border rounded-xl p-4 bg-card hover:border-foreground/30 transition-colors"
                >
                  <img src={cert.image} alt={cert.title} className="h-12 w-12 object-contain shrink-0" loading="lazy" />
                  <div className="min-w-0">
                    <h3 className="text-sm font-medium text-foreground truncate">{cert.title}</h3>
                    <p className="text-xs text-muted-foreground">{cert.issuer} -. {cert.date}</p>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </section>

        <Testimonials />

        {/* Achievements */}
        <section id="achievements" className="border-t border-border">
          <div className="max-w-6xl mx-auto px-6 py-24 md:py-32">
            <div className="mb-12 md:mb-16">
              <p className="text-xs uppercase tracking-[0.2em] text-muted-foreground mb-6">05 --- Recognition</p>
              <h2 className="font-display text-4xl md:text-5xl leading-[1.05] text-foreground">Achievements.</h2>
            </div>
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {achievements.map((a, index) => (
                <a
                  key={index}
                  href={a.link || '#'}
                  target={a.link ? '_blank' : undefined}
                  rel="noopener noreferrer"
                  className="group block"
                >
                  <div className="aspect-[4/3] overflow-hidden rounded-xl bg-muted border border-border mb-4">
                    <img src={a.image} alt={a.title} className="h-full w-full object-cover group-hover:-translate-y-0.5 transition-transform duration-500" loading="lazy" />
                  </div>
                  <h3 className="text-sm font-medium text-foreground leading-snug">{a.title}</h3>
                  <p className="text-xs text-muted-foreground mt-1">{a.issuer} -. {a.date}</p>
                </a>
              ))}
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="border-t border-border">
          <div className="max-w-6xl mx-auto px-6 py-24 md:py-32">
            <p className="text-xs uppercase tracking-[0.2em] text-muted-foreground mb-6">06 - Let's talk</p>
            <h2 className="font-display text-5xl md:text-7xl leading-[0.95] text-foreground max-w-3xl">
              Have an idea worth building?
            </h2>
            <p className="mt-6 text-lg text-muted-foreground max-w-xl">
              I'm open to interesting problems, collaborations and full-time roles. The fastest way to reach me is email.
            </p>
            <div className="mt-10 flex flex-wrap gap-3">
              <Button
                className="rounded-full px-6 h-11"
                onClick={() => (window.location.href = 'mailto:bmohanbalaji1976@gmail.com')}
              >
                bmohanbalaji1976@gmail.com <ArrowRight className="ml-2 h-4 w-4" />
              </Button>
              <Button variant="outline" className="rounded-full px-6 h-11" onClick={() => (window.location.href = 'https://www.linkedin.com/in/mohanbalaji2004/')}>
                LinkedIn
              </Button>
            </div>
          </div>
        </section>

        <Contact />
      </main>
    </>
  );
};

export default Index;



